import { render, staticRenderFns } from "./FormComponentLoader.vue?vue&type=template&id=96c9f61a&"
import script from "./FormComponentLoader.vue?vue&type=script&lang=js&"
export * from "./FormComponentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports